import { gql } from "@apollo/client";

export const GET_GROUP_BANK_ACCOUNTS = gql`
  query SpendGroupBankAccounts($groupId: String) {
    spendGroupBankAccounts(groupId: $groupId) {
      externalAccounts {
        accountId
        availableBalance
        currentBalance
        mask
        name
        officialName
        subtype
        type
        institution {
          id
          name
        }
      }
      status
    }
  }
`;
export const GET_GROUP_COUNTERPARTIES = gql`
  query SpendGetGroupCounterparties($groupOrOrgId: String!) {
    spendGetGroupCounterparties(groupOrOrgId: $groupOrOrgId) {
      counterparties {
        id
        name
        bankName
        routingNumber
        accountLastFour
        einNumber
      }
    }
  }
`;

export const GET_GROUP_PAYEES = gql`
  query SpendGroupPayees($groupId: String!) {
    spendGroupPayees(groupId: $groupId) {
      payees {
        id
        name
        address1
        address2
        city
        state
        zipCode
        einNumber
      }
    }
  }
`;

export const GET_GROUP_DEBIT_CARDS = gql`
  query SpendGroupDebitCards($spendGroupDebitCardsId: String) {
    spendGroupDebitCards(id: $spendGroupDebitCardsId) {
      cards {
        expiration
        id
        lastFour
        status
        userId
      }
      count
    }
  }
`;